import React, { Component } from 'react';
import qs from "qs";
import MaterialCard from '../materialCard';
import { getAllMaterial } from 'apis/material';
import { ch2Unicode } from "common/util";
import { ListView, PullToRefresh } from 'antd-mobile';
import "./index.less";

const NUM_ROWS = 10;// 控制每次加载所加载的行数
// 用于给每页的每条数据加上一个专属标识
function genData(pIndex = 1) {
    const dataArr = [];
    for (let i = 0; i < NUM_ROWS; i++) {
        dataArr.push(`row - ${(pIndex * NUM_ROWS) + i}`);
    }
    return dataArr;
}

export default class List extends Component {
    constructor(props) {
        super(props);

        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            materialAllData: [],
            dataSource,
            refreshing: true,
            isLoading: true,
            height: document.documentElement.clientHeight,
            offsetTopHeight: 0,
            allnums: 0,
            isPop: true
        }
    }

    reqMaterialData = []; // 用来存放从后端获取的每页的数据
    pageIndex = 1;// 首次加载可以看作这些加载的数据在第一页
    carrierData = [];

    componentDidUpdate(preProps, preState) {
        if (this.props.offsetTopHeight !== preProps.offsetTopHeight) {
            this.setState({
                offsetTopHeight: this.props.offsetTopHeight
            }, () => {
                let hei = this.state.height - this.state.offsetTopHeight;
                this.setState({
                    height: hei
                })
            })
        }
        const { begindate, enddate, pk_carriers, fstatusflag, concatnames } = this.props;
        let flag = false;

        if (pk_carriers.length !== this.carrierData.length) {
            flag = true;
        } else {
            pk_carriers?.forEach(item => {
                if (this.carrierData?.indexOf(item) === -1) {
                    flag = true;
                }
            })
        }
        if (begindate !== preProps.begindate
            || enddate !== preProps.enddate
            || fstatusflag !== preProps.fstatusflag
            || concatnames !== preProps.concatnames
            || flag
        ) {
            this.carrierData = [...pk_carriers];
            this.reqMaterialData = [];
            this.getData();
        }
    }

    componentDidMount() {
        this.getData();
    }

    formatDate(times) {
        var date = new Date(times);
        var year = date.getFullYear(); //年份
        var month = date.getMonth() + 1; //月份
        var day = date.getDate(); //日
        return year + '-' + month + '-' + day

    }

    //下拉刷新
    onRefresh = () => {
        this.setState({
            refreshing: true,
            isLoading: true,
            materialAllData: []
        });
        this.pageIndex = 1;
        this.reqMaterialData = [];
        this.getData();
    }



    //触底加载
    onEndReached = () => {
        const { allnums } = this.state;
        if (this.reqMaterialData.length >= allnums) {
            return;
        }
        this.setState({
            isLoading: true
        });
        ++this.pageIndex;

        this.getData();
    }

    getData = () => {
        const { type, concatnames, fstatusflag, begindate, enddate, pk_carriers } = this.props;
        let value = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');
        const { phoneNumber } = qs.parse(value);
        let concatname = ch2Unicode(concatnames);
        let paramData = {
            action: "1",
            appid: "",
            param: {
                telephone: phoneNumber,
                type, // 模拟请求数据是待办类型还是历史类型
                numsperpage: NUM_ROWS, // 模拟请求数据的行数
                page: this.pageIndex, // 模拟请求数据的页面的下标
                concatnames: concatname,
                begindate,
                enddate
                // pk_carriers
                // pk_stockorg:'0001A1100000000030MV',
                // pk_org:'0001A1100000000030MV',
                // VDEF6:'2022-06-28 11:33:10',
                // pk_material:'1001A11000000000AQTE'
            }
        }
        let params;

        if (!fstatusflag && fstatusflag !== 0) {
            params = paramData;
        } else {
            switch (type) {
                case "backlog":
                    params = paramData;
                    break;
                case "history":
                    Object.assign(paramData.param, { fstatusflag });
                    params = paramData;
                    break;
            }
        }

        let result = getAllMaterial(params);
        result.then(res => {
            if (res) {
                if (JSON.stringify(res.datas) !== "{}") {
                    let materialData = res.datas.queryresults;
                    let allnums = res.datas.allnums;
                    this.setState({
                        allnums
                    })
                    this.reqMaterialData = [...new Set([...this.reqMaterialData, ...materialData])];
                    if (this.pageIndex === 1) {
                        setTimeout(() => {
                            this.rData = genData();
                            this.setState({
                                materialAllData: this.reqMaterialData,
                                dataSource: this.state.dataSource.cloneWithRows([this.rData]),
                                refreshing: false,
                                isLoading: false
                            })
                        }, 1000)

                    } else {

                        setTimeout(() => {
                            this.rData = [...this.rData, ...genData(this.pageIndex)];
                            this.setState({
                                materialAllData: this.reqMaterialData,
                                dataSource: this.state.dataSource.cloneWithRows([this.rData]),
                                isLoading: false
                            })
                        }, 1000)
                    }
                } else {
                    this.setState({
                        materialAllData: this.reqMaterialData,
                    });
                    setTimeout(() => {
                        this.setState({
                            isLoading: false,
                            refreshing: false
                        })
                    }, 1000)
                }
            } else {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        refreshing: false
                    })
                }, 1000)
            }
        });
    }

    render() {
        const { materialAllData, dataSource, isLoading, height, refreshing } = this.state;
        const row = () => {
            return materialAllData.map((item, index) => {
                return <MaterialCard key={index + item.vbillcode} item={item} {...this.props}></MaterialCard> // 这里的key值到时候需要修改
            })
        };

        let empty = (
            <div className="list-empty">
                <div className="list-empty-img"></div>
                <div>暂无任务</div>
            </div>
        )


        let showView;
        if (isLoading) {
            showView = "拼命加载中...";
        } else {
            if (materialAllData.length !== 0) {
                showView = "—— 没有更多了 ——";
            } else {
                showView = <div>{empty}</div>
            }
        }
        return (
            <ListView
                dataSource={dataSource}
                renderFooter={() => (<div style={{ textAlign: 'center' }}>
                    {showView}
                </div>)}
                renderRow={row}
                initialListSize={10}
                style={{ height: height }}
                pullToRefresh={<PullToRefresh
                    refreshing={refreshing}
                    onRefresh={this.onRefresh}
                />}
                onEndReached={this.onEndReached}
                pageSize={2}
            ></ListView>
        )
    }
}
